export default class TutorialController {
  tutorials = [];

  constructor(tutorials = []) {
    this.tutorials = tutorials;
  }

  getTutorials() {
    return this.tutorials;
  }

  setTutorials(tutorials) {
    this.tutorials = tutorials;
  }

  addTutorials(tutorial) {
    this.tutorials.push(tutorial);
  }

  findElement(queryString) {
    const els = document.querySelectorAll(queryString);
    if (!!els?.length) {
      return Array.from(els).find((el) => {
        const computedStyle = window.getComputedStyle(el);
        const display = computedStyle.getPropertyValue('display');
        return display != 'none';
      });
    }
    return null;
  }

  getLikeCorrectArray() {
    return this.getTutorials().map((tutorial) => {
      const customStyles = {};
      if (tutorial.orientation) {
        customStyles.maxWidth = '250px';
      }
      return {
        title: tutorial.title,
        orientation: tutorial.orientation,
        content: tutorial.text ?? [],
        querySelector: tutorial.querySelector ?
          () => this.findElement(tutorial.querySelector) :
          null,
        skipWithoutElement: tutorial.skipWithoutElement,
        showLight: true,
        customStyles,
      };
    });
  }
}
